import * as React from 'react';

import { useOfferMessageTooltip } from '../provider';
import { useObserver } from '../../../../../hooks/useObserver';
import { IOfferForClient1 } from '../../../../../repositories/chats/entities/for_client/OfferForClient1';

interface IUseOfferTooltipObserverArgs {
  offer: IOfferForClient1 | undefined;
  isExpertEnabled: boolean | undefined;
  isChatbotChat: boolean;
  isOutcoming: boolean;
  messageRef: React.RefObject<HTMLDivElement | null>;
}

interface IUseOfferTooltipObserverResult {
  offerMessageTooltipState: { offerId: number; isVisible: boolean } | null;
  rootRef: React.RefObject<HTMLDivElement | null>;
  rootElementRef: React.RefObject<HTMLDivElement | null>;
  hideTooltip: () => void;
}

export const useOfferTooltipObserver = ({
  offer,
  isExpertEnabled,
  isChatbotChat,
  isOutcoming,
  messageRef,
}: IUseOfferTooltipObserverArgs): IUseOfferTooltipObserverResult => {
  const { showTooltip, hideTooltip, offerMessageTooltipState, rootRef } = useOfferMessageTooltip();
  const rootElementRef = React.useRef<HTMLDivElement | null>(null);

  const tooltipHandler = React.useCallback(() => {
    if (isExpertEnabled && !offerMessageTooltipState?.isVisible && offer && offer.realtyOfferId && !isOutcoming) {
      setTimeout(() => {
        showTooltip(offer.realtyOfferId);
      }, 4000);
    }
  }, [isExpertEnabled, offerMessageTooltipState?.isVisible, offer, isOutcoming, showTooltip]);

  useObserver({
    rootElementRef,
    targetElementRef: messageRef,
    condition: isChatbotChat,
    handler: tooltipHandler,
  });

  return { offerMessageTooltipState, rootRef, rootElementRef, hideTooltip };
};
